"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _WidgetComponentRenderer = _interopRequireWildcard(require("./WidgetComponentRenderer"));

var _ReasoningTrace = _interopRequireWildcard(require("./ReasoningTrace"));

var _FollowUpPills = _interopRequireDefault(require("./FollowUpPills"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var AgentMessage = function AgentMessage(_ref) {
  var turn = _ref.turn,
      isLastAgentTurn = _ref.isLastAgentTurn,
      disabled = _ref.disabled,
      onButtonSelect = _ref.onButtonSelect,
      onFormSubmit = _ref.onFormSubmit,
      onFollowUpSelect = _ref.onFollowUpSelect;
  var articles = (0, _ReasoningTrace.extractArticlesFromComponents)(turn.components);
  var hasRenderable = turn.components.some(_WidgetComponentRenderer.isSupportedComponent);
  return (0, _preact.h)("div", {
    className: "forethought-agent__turn forethought-agent__turn--agent"
  }, (0, _preact.h)("div", {
    className: "forethought-agent__bubble forethought-agent__bubble--agent"
  }, hasRenderable ? turn.components.map(function (component, index) {
    return (0, _preact.h)(_WidgetComponentRenderer.default, {
      key: "".concat(turn.id, "-").concat(index),
      component: component,
      disabled: disabled,
      onButtonSelect: onButtonSelect,
      onFormSubmit: onFormSubmit
    });
  }) : (0, _preact.h)("div", {
    className: "forethought-agent__fallback"
  }, "The agent didn't return a displayable response. Try rephrasing your question."), (0, _preact.h)(_ReasoningTrace.default, {
    components: turn.components,
    responseTimeMs: turn.responseTimeMs
  })), isLastAgentTurn && articles.length > 0 && (0, _preact.h)(_FollowUpPills.default, {
    articles: articles,
    disabled: disabled,
    onSelect: onFollowUpSelect
  }));
};

var _default = AgentMessage;
exports.default = _default;